import { useState, useEffect } from 'react';

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};

export const useIsMobile = () => {
  const { width } = useScreenSize();
  return width <= 480;
};

export const useIsTablet = () => {
  const { width } = useScreenSize();
  return width >= 481 && width <= 1366;
};

export const useIsDesktop = () => {
  const { width } = useScreenSize();
  return width >= 1367;
};

export const useShowMobileBreadcrumbs = () => {
  const { width } = useScreenSize();
  return width <= 1366;
};
